import { render, staticRenderFns } from "./JgpLoading.vue?vue&type=template&id=09701c37&"
import script from "./JgpLoading.vue?vue&type=script&lang=js&"
export * from "./JgpLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports